import { LiquidProduct } from '@/features/product/types'
import { useEffect, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { getVariantFromOptions } from '../utils'

export const useVariantUpdate = (
  optionsFieldName: string,
  variantFieldName: string,
  variants: LiquidProduct['variants'],
) => {
  const { setValue } = useFormContext()
  const selectedOptions: string[] = useWatch({ name: optionsFieldName })

  // Compute variant synchronously to avoid race condition
  // where selectedOptions updates before variant form state
  const variant = useMemo(
    () => getVariantFromOptions(selectedOptions, variants ?? []),
    [selectedOptions, variants],
  )

  // Sync to form state for submission
  useEffect(() => {
    setValue(variantFieldName, variant)
  }, [variant, variantFieldName, setValue])

  return variant
}
